import { getBookingDraftCount, getBookingDraftInfo, getBookingDrafts, type ApiListParams } from '@dc-trans/data-layer';
import { useQuery } from '@tanstack/react-query';

export const useBookingOnDemand = (params?: ApiListParams<any>, queryKey?: any[]) => {
  return useQuery({
    queryKey: queryKey ? [...queryKey, params] : ['booking-on-demand', params],
    queryFn: () => getBookingDrafts(params),
    gcTime: 0,
    staleTime: 0,
  });
};

export const useBookingOnDemandCount = () => {
  return useQuery({
    queryKey: ['booking-on-demand', 'counts'],
    queryFn: () => getBookingDraftCount(),
  });
};

export const useBookingOnDemandInfoById = (id?: string, enabled?: boolean) => {
  return useQuery({
    queryKey: ['booking-on-demand', id, 'info'],
    queryFn: () => {
      if (!id) return null;
      return getBookingDraftInfo(id);
    },
    enabled: enabled ? enabled && !!id : !!id,
    gcTime: 0,
    staleTime: 0,
  });
};
